/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface ProcedureTransactionHoldingSimpleViewModel {
  id?: string;
  procedureCode?: string | null;
  procedureDescription?: string | null;
  serviceDate?: string | null;
  amount?: number | null;
  placeOfService?: string | null;
  placeOfServiceDescription?: string | null;
  attendingProvider?: string | null;
  attendingProviderDescription?: string | null;
  referringProvider?: string | null;
  referringProviderDescription?: string | null;
  location?: string | null;
  locationDescription?: string | null;
}
